/* tslint:disable */
/* eslint-disable */
/**
 * Bioplan API
 * Backend API for Bioplan, an aquaculture production planning tool.
 *
 * Contact: support@optimeeringaqua.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type {Configuration} from '../configuration';
import type {AxiosPromise, AxiosInstance, RawAxiosRequestConfig} from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import {
  DUMMY_BASE_URL,
  assertParamExists,
  setApiKeyToObject,
  setBasicAuthToObject,
  setBearerAuthToObject,
  setOAuthToObject,
  setSearchParams,
  serializeDataIfNeeded,
  toPathString,
  createRequestFunction,
} from '../common';
// @ts-ignore
import {BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap} from '../base';
// @ts-ignore
import type {Region} from '../bioplanModels';
/**
 * PlanningRegionApi - axios parameter creator
 * @export
 */
export const PlanningRegionApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     *
     * @summary Get all regions, filtered by plan ID
     * @param {string} planId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    regionsGet: async (planId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
      // verify required parameter 'planId' is not null or undefined
      assertParamExists('regionsGet', 'planId', planId);
      const localVarPath = `/regions/`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {method: 'GET', ...baseOptions, ...options};
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      if (planId !== undefined) {
        localVarQueryParameter['planId'] = planId;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Create region
     * @param {Region} region
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    regionsPost: async (region: Region, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
      // verify required parameter 'region' is not null or undefined
      assertParamExists('regionsPost', 'region', region);
      const localVarPath = `/regions/`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {method: 'POST', ...baseOptions, ...options};
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
      localVarRequestOptions.data = serializeDataIfNeeded(region, localVarRequestOptions, configuration);

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Delete region by its identifier
     * @param {string} regionId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    regionsRegionIdDelete: async (regionId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
      // verify required parameter 'regionId' is not null or undefined
      assertParamExists('regionsRegionIdDelete', 'regionId', regionId);
      const localVarPath = `/regions/{regionId}`.replace(`{${'regionId'}}`, encodeURIComponent(String(regionId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {method: 'DELETE', ...baseOptions, ...options};
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Get region by its identifier
     * @param {string} regionId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    regionsRegionIdGet: async (regionId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
      // verify required parameter 'regionId' is not null or undefined
      assertParamExists('regionsRegionIdGet', 'regionId', regionId);
      const localVarPath = `/regions/{regionId}`.replace(`{${'regionId'}}`, encodeURIComponent(String(regionId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {method: 'GET', ...baseOptions, ...options};
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Update region
     * @param {string} regionId
     * @param {Region} region
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    regionsRegionIdPut: async (
      regionId: string,
      region: Region,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'regionId' is not null or undefined
      assertParamExists('regionsRegionIdPut', 'regionId', regionId);
      // verify required parameter 'region' is not null or undefined
      assertParamExists('regionsRegionIdPut', 'region', region);
      const localVarPath = `/regions/{regionId}`.replace(`{${'regionId'}}`, encodeURIComponent(String(regionId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {method: 'PUT', ...baseOptions, ...options};
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
      localVarRequestOptions.data = serializeDataIfNeeded(region, localVarRequestOptions, configuration);

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * PlanningRegionApi - functional programming interface
 * @export
 */
export const PlanningRegionApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = PlanningRegionApiAxiosParamCreator(configuration);
  return {
    /**
     *
     * @summary Get all regions, filtered by plan ID
     * @param {string} planId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async regionsGet(
      planId: string,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Region>>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.regionsGet(planId, options);
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['PlanningRegionApi.regionsGet']?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Create region
     * @param {Region} region
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async regionsPost(
      region: Region,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Region>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.regionsPost(region, options);
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['PlanningRegionApi.regionsPost']?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Delete region by its identifier
     * @param {string} regionId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async regionsRegionIdDelete(
      regionId: string,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.regionsRegionIdDelete(regionId, options);
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['PlanningRegionApi.regionsRegionIdDelete']?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Get region by its identifier
     * @param {string} regionId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async regionsRegionIdGet(
      regionId: string,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Region>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.regionsRegionIdGet(regionId, options);
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['PlanningRegionApi.regionsRegionIdGet']?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Update region
     * @param {string} regionId
     * @param {Region} region
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async regionsRegionIdPut(
      regionId: string,
      region: Region,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Region>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.regionsRegionIdPut(regionId, region, options);
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['PlanningRegionApi.regionsRegionIdPut']?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
  };
};

/**
 * PlanningRegionApi - factory interface
 * @export
 */
export const PlanningRegionApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance,
) {
  const localVarFp = PlanningRegionApiFp(configuration);
  return {
    /**
     *
     * @summary Get all regions, filtered by plan ID
     * @param {PlanningRegionApiRegionsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    regionsGet(
      requestParameters: PlanningRegionApiRegionsGetRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<Array<Region>> {
      return localVarFp.regionsGet(requestParameters.planId, options).then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Create region
     * @param {PlanningRegionApiRegionsPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    regionsPost(
      requestParameters: PlanningRegionApiRegionsPostRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<Region> {
      return localVarFp.regionsPost(requestParameters.region, options).then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Delete region by its identifier
     * @param {PlanningRegionApiRegionsRegionIdDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    regionsRegionIdDelete(
      requestParameters: PlanningRegionApiRegionsRegionIdDeleteRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<void> {
      return localVarFp
        .regionsRegionIdDelete(requestParameters.regionId, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Get region by its identifier
     * @param {PlanningRegionApiRegionsRegionIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    regionsRegionIdGet(
      requestParameters: PlanningRegionApiRegionsRegionIdGetRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<Region> {
      return localVarFp
        .regionsRegionIdGet(requestParameters.regionId, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Update region
     * @param {PlanningRegionApiRegionsRegionIdPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    regionsRegionIdPut(
      requestParameters: PlanningRegionApiRegionsRegionIdPutRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<Region> {
      return localVarFp
        .regionsRegionIdPut(requestParameters.regionId, requestParameters.region, options)
        .then((request) => request(axios, basePath));
    },
  };
};

/**
 * Request parameters for regionsGet operation in PlanningRegionApi.
 * @export
 * @interface PlanningRegionApiRegionsGetRequest
 */
export interface PlanningRegionApiRegionsGetRequest {
  /**
   *
   * @type {string}
   * @memberof PlanningRegionApiRegionsGet
   */
  readonly planId: string;
}

/**
 * Request parameters for regionsPost operation in PlanningRegionApi.
 * @export
 * @interface PlanningRegionApiRegionsPostRequest
 */
export interface PlanningRegionApiRegionsPostRequest {
  /**
   *
   * @type {Region}
   * @memberof PlanningRegionApiRegionsPost
   */
  readonly region: Region;
}

/**
 * Request parameters for regionsRegionIdDelete operation in PlanningRegionApi.
 * @export
 * @interface PlanningRegionApiRegionsRegionIdDeleteRequest
 */
export interface PlanningRegionApiRegionsRegionIdDeleteRequest {
  /**
   *
   * @type {string}
   * @memberof PlanningRegionApiRegionsRegionIdDelete
   */
  readonly regionId: string;
}

/**
 * Request parameters for regionsRegionIdGet operation in PlanningRegionApi.
 * @export
 * @interface PlanningRegionApiRegionsRegionIdGetRequest
 */
export interface PlanningRegionApiRegionsRegionIdGetRequest {
  /**
   *
   * @type {string}
   * @memberof PlanningRegionApiRegionsRegionIdGet
   */
  readonly regionId: string;
}

/**
 * Request parameters for regionsRegionIdPut operation in PlanningRegionApi.
 * @export
 * @interface PlanningRegionApiRegionsRegionIdPutRequest
 */
export interface PlanningRegionApiRegionsRegionIdPutRequest {
  /**
   *
   * @type {string}
   * @memberof PlanningRegionApiRegionsRegionIdPut
   */
  readonly regionId: string;

  /**
   *
   * @type {Region}
   * @memberof PlanningRegionApiRegionsRegionIdPut
   */
  readonly region: Region;
}

/**
 * PlanningRegionApi - object-oriented interface
 * @export
 * @class PlanningRegionApi
 * @extends {BaseAPI}
 */
export class PlanningRegionApi extends BaseAPI {
  /**
   *
   * @summary Get all regions, filtered by plan ID
   * @param {PlanningRegionApiRegionsGetRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PlanningRegionApi
   */
  public regionsGet(requestParameters: PlanningRegionApiRegionsGetRequest, options?: RawAxiosRequestConfig) {
    return PlanningRegionApiFp(this.configuration)
      .regionsGet(requestParameters.planId, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Create region
   * @param {PlanningRegionApiRegionsPostRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PlanningRegionApi
   */
  public regionsPost(requestParameters: PlanningRegionApiRegionsPostRequest, options?: RawAxiosRequestConfig) {
    return PlanningRegionApiFp(this.configuration)
      .regionsPost(requestParameters.region, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Delete region by its identifier
   * @param {PlanningRegionApiRegionsRegionIdDeleteRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PlanningRegionApi
   */
  public regionsRegionIdDelete(
    requestParameters: PlanningRegionApiRegionsRegionIdDeleteRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return PlanningRegionApiFp(this.configuration)
      .regionsRegionIdDelete(requestParameters.regionId, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Get region by its identifier
   * @param {PlanningRegionApiRegionsRegionIdGetRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PlanningRegionApi
   */
  public regionsRegionIdGet(
    requestParameters: PlanningRegionApiRegionsRegionIdGetRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return PlanningRegionApiFp(this.configuration)
      .regionsRegionIdGet(requestParameters.regionId, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Update region
   * @param {PlanningRegionApiRegionsRegionIdPutRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PlanningRegionApi
   */
  public regionsRegionIdPut(
    requestParameters: PlanningRegionApiRegionsRegionIdPutRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return PlanningRegionApiFp(this.configuration)
      .regionsRegionIdPut(requestParameters.regionId, requestParameters.region, options)
      .then((request) => request(this.axios, this.basePath));
  }
}
